/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavedViewUpdateRequest extends models.SavedViewBase {
    getFixupPrototypeFunction() { return SavedViewUpdateRequest.fixupPrototype; }

    static newInstance(model: Partial<SavedViewUpdateRequest>): SavedViewUpdateRequest {
        let obj = Object.assign(new SavedViewUpdateRequest(), model);
        SavedViewUpdateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavedViewUpdateRequest>): SavedViewUpdateRequest {
        if (!model) return null;
        return SavedViewUpdateRequest.newInstance(<SavedViewUpdateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavedViewUpdateRequest) {
        if (!obj) return;

        models.SavedViewUpdateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavedViewUpdateRequest): boolean {
        if (models.SavedViewBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, SavedViewUpdateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
